module.exports = __webpack_public_path__ + "static/media/banner-min.93a7880b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/banner-min.jpg
// module id = 663
// module chunks = 0